import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ProtectedRoute from "./routes/ProtectedRoute";

// PUBLIC
import Login from "./Authentication/login";
import Signup from "./Authentication/signUp";
import LandingPage from "./Users/components/landing/LandingPage";
import AboutPage from "./Users/components/about/AboutPage";
import ContactPage from "./Users/components/contact/ContactPage";
import PricingPage from "./Users/components/pricing/PricingPage";
import FeaturesPage from "./Users/components/features/FeaturesPage";
import GoogleAuthCallback from "./routes/googleAuthCallback";
import ChangePassword from "./Authentication/createPassword";

// STUDENT
import ProfilePage from "./Users/components/profile/ProfilePage";
import DashboardPage from "./Users/components/dashboard/DashboardPage";
import AiraChatPage from "./Users/components/airachat/AiraChatPage";
import Codechecker from "./Users/components/coding/code_checker";
import CodingPageNew from "./Users/components/coding/CodingPageNew";
import FlowChartPage from "./Users/components/flowchart/FlowChartPage";
import TestPage from "./Users/components/test/TestPage";
import TestMCQPage from "./Users/components/test/TestMCQPage";
import TestFillBlanksPage from "./Users/components/test/TestFillBlanksPage";
// import TestShortAnsPage from "./Users/components/test/TestShortAnsPage";
import ShowAllAnswersPage from "./Users/components/test/ShowAllAnswersPage";
import ReasoningPage from "./Users/components/reasoning/ReasoningPage";
import FlashcardPage from "./Users/components/flashcard/FlashcardPage";
import UploadPage from "./Users/components/uploads/UploadPage";
// import QuestionAnswerPage from "./Users/components/test-generation/QuestionAnswerPage";
import CodingAnalysisPage from "./Users/components/Analytics";

// TEACHER
import TeacherMainPage from "./Users/components/teacher/teacher_mainPage";
import TeacherProfilePage from "./Users/components/teacher/teacher_profile/ProfilePage";
import NoticeBoardMainPage from "./Users/components/teacher/notice_board";
import NoticeBoardMainPage1 from "./Users/components/teacher/notice_boardPage1";
import CreateQuiz from "./Users/components/teacher/teacher_CreateQuiz/createQuiz";
import CourseManagement from './Users/components/teacher/teacher_CreateCourse/CreateCourse';
import QuizAssesmntHistory from './Users/components/teacher/QuizAssesmentHistory/QuizAssesmntHistory';
import PrepSelection from './Users/components/test/CAT/PrepSelection';


// ADMIN
import PeoplePage from "./Admin/people";
import { useNetworkStatus } from "./Reusable_Components/networkStatus";
import ShowAllAnswers from "./Users/components/test/Future_Test/ShowAnswers";
import FutureTestQuestions from "./Users/components/test/Future_Test/FutureTestQuestions";
import ReportMainPage from "./Users/components/teacher/report";
import ForgotPassword from "./Authentication/forgotPassword";
import AdminProfilePage from "./Admin/admin_profile/ProfilePage";
import ReportDetailedView from "./Users/components/teacher/report/reportDetailedView";
import CodingReport from "./Users/components/Analytics/CodingReport";
import ShowTestUnattempted from "./Users/components/test/showTestUnAttempted";
import AdminReportBody from "./Admin/report/adminReport";
import NoticeBoardStudentPage from "./Users/components/notice_board_student";
import CohortList from "./Users/components/teacher/cohort/CohortList";
import AdminCohortMainPage from "./Admin/cohort";

function App() {
  const isOnline = useNetworkStatus();

  return (
    <>
      {!isOnline && (
        <div className="no-internet">
          You’re offline. Some features may not work.
        </div>
      )}

      <BrowserRouter>
        <Routes>
          {/* PUBLIC */}
          <Route path="/signup" element={<Signup />} />
          <Route path="/home" element={<LandingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/features" element={<FeaturesPage />} />
          <Route
            path="/google-auth-callback"
            element={<GoogleAuthCallback />}
          />
          <Route path="/change-password" element={<ChangePassword />} />
           <Route path="/forgot-password" element={<ForgotPassword />} />

          {/* SHARED : Student + Teacher + Admin */}
          <Route element={<ProtectedRoute allowedRoles={[1, 2, 3]} />}>
            <Route path="/airachat" element={<AiraChatPage />} />
            <Route path="/coding" element={<CodingPageNew />} />
            <Route path="/codeChecker" element={<Codechecker />} />
          </Route>

          {/* STUDENT : role = 1 */}
          <Route element={<ProtectedRoute allowedRoles={[1]} />}>
            <Route path="/userprofile" element={<ProfilePage />} />
            <Route path="/dashboard-page" element={<DashboardPage />} />
            <Route path="/flashcard" element={<FlashcardPage />} />
            <Route path="/uploads" element={<UploadPage />} />
            <Route path="/dynamic-links" element={<CodingAnalysisPage />} />
            <Route path="/coding-report" element={<CodingReport />} />
            <Route path="/future-test" element={<FutureTestQuestions />} />
            <Route path="/show-answers" element={<ShowAllAnswers />} />   {/* future test */}
           <Route path="/showallanswers" element={<ShowAllAnswersPage />} /> {/* student test and history*/}
            <Route path="/test" element={<TestPage />} />
            <Route path="/mcqtest" element={<TestMCQPage />} />
            <Route path="/fillblankstest" element={<TestFillBlanksPage />} />
            <Route path="/test-unattempted" element={<ShowTestUnattempted />} />
            <Route path="/notice-board-student" element={<NoticeBoardStudentPage />} />
            
            {/* <Route path="/questions" element={<QuestionAnswerPage />} /> */}
            <Route path="/reasoning" element={<ReasoningPage />} />
            
          </Route>

        {/* TEACHER : role = 2 */}
        <Route element={<ProtectedRoute allowedRoles={[2]} />}>
          <Route path="/teacher" element={<TeacherMainPage />} />
          <Route path="/teacher-profile" element={<TeacherProfilePage />} />
          <Route path="/notice-board" element={<NoticeBoardMainPage />} />
          <Route path="/notice-board1" element={<NoticeBoardMainPage1 />} />
          <Route path="/create-quiz" element={<CreateQuiz />} />
          <Route path="/create-course" element={<CourseManagement />} />
          <Route path="/report" element={<ReportMainPage />} />
          <Route path="/report-detailed-view" element={<ReportDetailedView />} />
          <Route path="/assessment-history" element={<QuizAssesmntHistory />} />
           <Route path="/cohort" element={<CohortList />} />
          <Route 
          path="/prep-selection" 
          element={<PrepSelection />} 
        />
        </Route>

          {/* ADMIN : role = 3 */}
          <Route element={<ProtectedRoute allowedRoles={[3]} />}>
            <Route path="/people" element={<PeoplePage />} />
             <Route path="/admin-profile" element={<AdminProfilePage />} />
            <Route path="/admin-report" element={<AdminReportBody />} />   
            <Route path="/admin-cohort" element={<AdminCohortMainPage />} />      
          </Route>

          {/* FALLBACK */}
          <Route path="*" element={<Login />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
